/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { ArrowDown, } from '@one-thd/sui-icons';
import { Button } from '@one-thd/sui-atomic-components';
import { useDrawer, useDrawerStore } from '../DrawerProvider';
import { useAssistantStore } from '../../../orchestrator/AssistantOrchestrator';

export const ScrollToBottomButton = () => {
  const messages = useAssistantStore((state) => state.messages);
  const { scrollToBottom, forceIsAtBottomCheck } = useDrawer();
  // The only component that reacts to scroll position — subscribe to just that
  // slice so scrolling re-renders this button and nothing else.
  const isUserScrolledToBottom = useDrawerStore((state) => state.isUserScrolledToBottom);

  useEffect(() => {
    forceIsAtBottomCheck();
  }, [messages]);

  if (isUserScrolledToBottom) return null;

  return (
    <div className="sui-absolute sui-left-0 sui-right-0 sui-top-2 sui-flex sui-justify-center">
      <Button
        aria-label="Scroll To Bottom"
        onClick={() => scrollToBottom('smooth')}
        className="sui-bottom-full sui-absolute sui-h-11 sui-w-11 sui-rounded-full sui-bg-primary sui-shadow-md hover:sui-bg-brand hover:sui-text-inverse focus-visible:sui-bg-focus focus-visible:sui-text-primary"
      >
        <ArrowDown className="sui-pt-2 sui-inline-block sui-align-baseline sui-fill-current sui-w-6 sui-h-7" />
      </Button>
    </div>
  );
};

ScrollToBottomButton.propTypes = {};
